import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    private isSpinningSubject = new BehaviorSubject<boolean>(false);

    public isSpinning$ = this.isSpinningSubject.asObservable();

    constructor() {}

    public show(): void {
        this.isSpinningSubject.next(true);
    }

    public hide(): void {
        this.isSpinningSubject.next(false);
    }
}
